import * as firebaseHelpers from '../Firebase';

export async function updatePassword(password) {
  const user = await firebaseHelpers.getCurrentUser();
  await user.updatePassword(password);
}